import type { DashboardUser } from '../auth/auth-adapter'
import { getEnvironment } from '../../lib/environment'
import { createApiClient } from '../../services/api/client'
import {
  bookingCheckResolutionResponseSchema,
  bookingChecksResponseSchema,
  type BookingCheck,
  type BookingChecksResponse,
  type StaffResolution,
} from './booking-checks-contracts'

export type BookingChecksRepository = {
  list: (tenantId: string) => Promise<BookingChecksResponse>
  resolve: (
    tenantId: string,
    check: Pick<BookingCheck, 'bookingCheckId' | 'revision'>,
    resolutionType: StaffResolution
  ) => Promise<BookingCheck>
}

type RepositoryOptions = {
  getUser: () => DashboardUser | null
  baseUrl?: string
  fetchImplementation?: typeof fetch
}

function collection(tenantId: string) {
  return `/dashboard/clinics/${encodeURIComponent(tenantId)}/booking-checks`
}

export function createBookingChecksRepository({
  getUser,
  baseUrl = getEnvironment().userManagementBaseUrl,
  fetchImplementation,
}: RepositoryOptions): BookingChecksRepository {
  const client = createApiClient({ baseUrl, getUser, fetchImplementation })
  return {
    list(tenantId) {
      return client.request(collection(tenantId), {
        method: 'GET',
        responseSchema: bookingChecksResponseSchema,
      })
    },
    async resolve(tenantId, check, resolutionType) {
      const result = await client.request(
        `${collection(tenantId)}/${encodeURIComponent(check.bookingCheckId)}/resolve`,
        {
          method: 'POST',
          body: { expectedRevision: check.revision, resolutionType },
          responseSchema: bookingCheckResolutionResponseSchema,
        }
      )
      const { outcome, ...stored } = result
      void outcome
      return stored
    },
  }
}
